import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var LotOutlineSVG = function LotOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M30.9 26.4l-5.6-8a1 1 0 00-.8-.4H13v-2a4.7 4.7 0 004-4.5 4.3 4.3 0 00-1.6-3.3 4 4 0 10-6.8 0A4.3 4.3 0 007 11.5a4.7 4.7 0 004 4.4V18H7.5a1 1 0 00-.8.4l-5.6 8a1 1 0 00.8 1.6h28.2a1 1 0 00.8-1.6zM9 11.5a2.3 2.3 0 011-1.8 2 2 0 00.3-2.6A2 2 0 0110 6a2 2 0 014 0 2 2 0 01-.3 1 2 2 0 00.4 2.7 2.3 2.3 0 01.9 1.8 2.6 2.6 0 01-2 2.4V11a1 1 0 00-2 0v2.9a2.6 2.6 0 01-2-2.4zM3.8 26L8 20h3v2a1 1 0 002 0v-2h11l4.2 6z"
  }));
};
LotOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LotOutlineSVG);